module.exports = __webpack_public_path__ + "static/media/NJFarmingFlourishes_logo.207c3bfc.png";